/**
 * "Skip for now" affordance shown under the primary CTA on the optional
 * wizard steps.
 */
import { Button } from '@/lib/base/buttons/button';

interface SkipButtonProps {
  onSkip: () => void;
}

export function SkipButton({ onSkip }: SkipButtonProps) {
  return (
    <Button color='link-gray' size='sm' onClick={onSkip} className='mx-auto'>
      Skip for now
    </Button>
  );
}
